import { ajaxGet, httpActions } from '@figure/frontlib-onboarding-redux';

const { baseUrl } = httpActions;
const EXTERNAL = `${baseUrl()}/service-application-pl/external/api/v1/application`;

export const GET_ELIGIBLE_STATES = 'PL:GET_ELIGIBLE_STATES';

export const getEligibleStates = () => async (dispatch) => ajaxGet(GET_ELIGIBLE_STATES, dispatch, `${EXTERNAL}/states-eligibility`);
